import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  root: {},
  tabs: {
    minHeight: 34
  },
  tab: {
    fontSize: 16,
    minHeight: 34,
    textTransform: "none",
    borderBottom: `1px solid ${theme.palette.text.hint}`,
    padding: "0 12px",
    color: theme.palette.text.hint,
    "&.Mui-selected": {
      color: theme.palette.text.primary,
      fontFamily: "SuisseIntlMedium, SuisseIntlRegular"
    }
  },
  views: {
    "& div": {
      '&[aria-hidden="false"]': {
        height: "100%"
      },
      '&[aria-hidden="true"]': {
        height: "0"
      }
    }
  }
}));
